<template>
  <div class="room remote-history" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="table-command-container">
      <div class="table-command">
        <!-- <span class="table-command-item-key dh-right">{{ bridgeName }}</span>
        <div class="table-command-item">
          <span class="table-command-item-key">设备组:</span>
          <el-select v-model="selectedStation" placeholder="请选择设备组">
            <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName"
              :value="item.stationId"></el-option>
          </el-select>
        </div>
        <div class="table-command-item">
          <span class="table-command-item-key">数据类型:</span>
          <el-select v-model="selectedDataType" placeholder="请选择数据类型">
            <el-option v-for="item in dataTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div> -->
      </div>
      <div class="table-command-right">
        <!-- <el-button @click="hrefErrorRecord()" v-if="bridgeHasErrorRecord" type="primary">报警记录</el-button> -->
      </div>
    </div>

    <el-table :data="dataList" style="width: 100%" :max-height="tableMaxHeight" @expand-change="onSubtaskExpand"
      row-key="missionId" class="mission-table">
      <el-table-column type="expand">
        <template slot-scope="props">
          <div class="table-expand-area">
            <!-- 子表格 -->
            <el-table :data="subTableMissionIdDataListDict[props.row.missionId]"
              :loading="subTableMissionIdLoadingDict[props.row.missionId]" class="subtask-table">
              <el-table-column align="center" label="任务名">
                <template slot-scope="scope">
                  <el-tooltip :content="scope.row.taskId">
                    {{ scope.row.taskName }}
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="taskType" label="任务类型"></el-table-column>
              <el-table-column align="center" prop="createdDate" label="创建时间"></el-table-column>
              <el-table-column align="center" prop="EndDate" label="结束时间"></el-table-column>
              <el-table-column align="center" label="任务状态">
                <template slot-scope="scope">
                  <el-tag class="mission-stage-tag" effect="dark" :type="scope.row.TaskStatusType">{{
                    scope.row.TaskStatus
                    }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="报错信息" prop="ExceptionMessage"></el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="任务名">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.missionId">
            {{ scope.row.missionName }}
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建用户" prop="userName"></el-table-column>
      <el-table-column align="center" label="创建时间" prop="createdDate"></el-table-column>
      <el-table-column align="center" label="遥控设备" prop="deviceFullName"></el-table-column>
      <el-table-column align="center" label="遥控目标" prop="commandValue"></el-table-column>
      <el-table-column align="center" label="任务状态">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.initStageTooptip">
            <el-tag class="mission-stage-tag" effect="dark" :type="scope.row.initStageType">初始化</el-tag>
          </el-tooltip>
          <el-tooltip :content="scope.row.dispatchStageTooptip">
            <el-tag class="mission-stage-tag" effect="dark" :type="scope.row.dispatchStageType">下发</el-tag>
          </el-tooltip>
          <el-tooltip :content="scope.row.confirmStageTooptip">
            <el-tag class="mission-stage-tag" effect="dark" :type="scope.row.confirmStageType">确认</el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column align="center" label="报错信息" prop="ExceptionMessage"></el-table-column>
    </el-table>
    <el-pagination class="pagination" :style="pageStyle" layout="prev, pager, next" :total="totalCount"
      :page-size="pageSize" @current-change="currentChange" :current-page.sync="currentPage" ref="page"></el-pagination>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { dateTimeToString, newtonsoftJsonToDate } from "../tools/GeneralTool";

export default {
  name: "SimpleCurrentData",
  data() {
    return {
      timer: null,
      dataList: [],
      subTableMissionIdDataListDict: {},
      subTableMissionIdLoadingDict: {},
      loading: false,
      shownewUser: false,
      checkUserId: "",
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      bridgeId: "",
      bridgeName: "",
      bridgeHasErrorRecord: false,
      bridgeTranslateDict: {},
      deviceTranslateDict: {},
      deviceNameReplaceList: ["状态", "(枚举)"],
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
      firstIndex: 0,
      lastIndex: 0,

      routeBridgeId: "",


    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "getIsAdmin",
      bridgeList: "getBridgeList",
    }),
  },
  mounted() {
    this.loading = true;

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };
    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    this.pageStyle = {
      left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
    };

    this.initializeStationAndGetData();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
        };
      });
    },
    $route(route) {
      if (this.$route.query.bridgeId !== this.routeBridgeId) {
        this.initializeStationAndGetData();
      }
    },
  },
  methods: {
    initializeStationAndGetData() {
      this.loading = true;
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.routeBridgeId = this.$route.query.bridgeId;
      let routeBridgeIdConfirmed = false;
      this.bridgeList.forEach((bridge) => {
        if (bridge.id === this.routeBridgeId) {
          routeBridgeIdConfirmed = true;
          //break
          return false;
        }
      });

      if (!routeBridgeIdConfirmed) {
        this.$alert("无效的桥梁编号", {
          confirmButtonText: "确定",
          showClose: true,
          type: "error",
          callback: (action) => {
            // console.log('stop');
            // this.resultObjectList = [];
          },
        });

        return;
      }

      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);

      this.$http.get("/bridge/bridgeinfo?bridgeId=" + this.routeBridgeId).then((res) => {
        this.$nextTick(() => {

          this.bridgeName = res.data.bridgeName;
          this.currentPage = 1;
          this.getData();
        });
      });
    },
    currentChange(index) {
      this.currentPage = index;
      this.getData();
    },
    refreshData() {
      this.getData();
    },
    onSubtaskExpand(row, expandRowList) {
      let isExpand = false;
      let missionId = row.missionId;
      for (let expandRowItem of expandRowList) {
        if (expandRowItem.missionId === missionId) {
          isExpand = true;
          break;
        }
      }

      if (isExpand) {
        //handle expand
        this.subTableMissionIdLoadingDict[missionId] = true;

        this.$nextTick(() => {
          let subtaskDataList = this.getSubtaskDataListForMission(missionId);
          this.subTableMissionIdDataListDict[missionId] = subtaskDataList;

          setTimeout(() => {
            this.subTableMissionIdDataListDict[missionId] = false;
          }, 500);

        })
      }
      else {
        //handle collapse
        this.subTableMissionIdDataListDict[missionId] = [];
      }

    },
    getData() {
      this.loading = true;
      this.getDataCount();
      this.getDataList();
    },
    getDataCount() {
      let url = "/remoteControl/GetRemoteMissionCount?bridgeId=" + this.routeBridgeId;

      this.$http.get(url).then((res) => {
        this.totalCount = res.data.count;
      });
    },
    getDataList() {
      let url = "/remoteControl/GetRemoteMission?start=" + (this.currentPage - 1) * this.pageSize + "&limit=" + this.pageSize + "&bridgeId=" + this.routeBridgeId;

      this.$http.get(url).then((res) => {
        let dataList = res.data;
        dataList.push({ 'missionId': 'id12345', 'missionName': '页面测试任务' })
        dataList.push({ 'missionId': 'id23456', 'missionName': '页面测试任务2' })
        for (let dataItem of dataList) {
          try {
            let date = newtonsoftJsonToDate(dataItem.createdDate);
            dataItem.createdDate = dateTimeToString(date, "YY年MM月dd日 HH:mm");
          } catch (e) {
            //pass
          }

          dataItem.initStageType = this.getStageTypeForMission(dataItem.initStatus);
          dataItem.initStageTooltip = this.getStageTooltipForMission(dataItem.initStatus);

          dataItem.dispatchStageType = this.getStageTypeForMission(dataItem.dispatchStatus);
          dataItem.dispatchStageTooltip = this.getStageTooltipForMission(dataItem.dispatchStatus);

          dataItem.confirmStageType = this.getStageTypeForMission(dataItem.confirmStatus);
          dataItem.confirmStageTooltip = this.getStageTooltipForMission(dataItem.confirmStatus);
        }

        this.dataList = dataList;
        this.subTableMissionIdDataListDict = {};
        this.subTableMissionIdLoadingDict = {};
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });

    },

    getSubtaskDataListForMission(missionId) {
      let url = "/remoteControl/GetRemoteSubtask?missionId=" + missionId;

      this.$http.get(url).then((res) => {
        let dataList = res.data;
        for (let dataItem of dataList) {
          try {
            let date = newtonsoftJsonToDate(dataItem.createdDate);
            dataItem.createdDate = dateTimeToString(date, "YY年MM月dd日 HH:mm");
          } catch (e) {
            //pass
          }

          if (dataItem.EndDate) {
            try {
              let date = newtonsoftJsonToDate(dataItem.EndDate);
              dataItem.EndDate = dateTimeToString(date, "YY年MM月dd日 HH:mm");
            } catch (e) {
              //pass
            }
          }

          if (dataItem.taskType === "MQTT") {
            dataItem.taskType = "指令下发(MQTT)"
          } else if (dataItem.taskType === "CONFIRM") {
            dataItem.taskType = "回值确认"
          } else {
            dataItem.taskType = "其他类型"
          }

          if (dataItem.TaskStatus === "RUNNING") {
            dataItem.TaskStatus = "运行中";
            dataItem.TaskStatusType = "warning";
          } else if (dataItem.TaskStatus === "COMPLETE") {
            dataItem.TaskStatus = "已完成";
            dataItem.TaskStatusType = "success";
          } else if (dataItem.TaskStatus === "FAILED") {
            dataItem.TaskStatus = "已失败";
            dataItem.TaskStatusType = "danger";
          } else {
            dataItem.TaskStatus = "NA";
            dataItem.TaskStatusType = "info";
          }

          setTimeout(() => {
            this.loading = false;
          }, 500);
        }
      });

    },

    getStageTypeForMission(stageStatus) {
      if (stageStatus === "PENDING") {
        return "primary"
      } else if (stageStatus === "RUNNING") {
        return "warning"
      }
      else if (stageStatus === "COMPLETE") {
        return "success"
      }
      else if (stageStatus === "FAILED") {
        return "danger"
      }
      else {
        return 'info'
      }
    },

    getStageTooltipForMission(stageStatus, concludedDate) {
      let tooltipDate = "";
      try {
        let date = newtonsoftJsonToDate(concludedDate);
        if (date > 0) {
          tooltipDate = dateTimeToString(date, "YY年MM月dd日 HH:mm");
        }
      }
      catch {
        //pass
      }

      if (stageStatus == "PENDING") {
        return "等待中. " + tooltipDate;
      } else if (stageStatus == "RUNNING") {
        return "运行中. " + tooltipDate;
      }
      else if (stageStatus == "COMPLETE") {
        return "已完成. " + tooltipDate;
      }
      else if (stageStatus == "FAILED") {
        return "已失败. " + tooltipDate;
      }
      else {
        return "NA. " + tooltipDate;
      }
    },

    translateBridgeName(bridgeId) {
      for (let bridge of this.bridgeList) {
        if (bridge.id === bridgeId) {
          return bridge.name;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.remote-history {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 20px) !important;
  position: relative;

  .table-command-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .table-command {
    display: flex;
  }

  .table-command-right {
    display: flex;
    margin-right: 20px;
  }

  .table-command-item-key {
    margin-right: 10px;
    margin-left: 20px;
    margin-top: 10px;
  }

  .pagination {
    position: absolute;
    bottom: 0;
  }
}

.status-tag {
  cursor: pointer;
}

.table-button {
  margin-bottom: 10px;
  margin-left: 10px;
}

.dialog-form-input {
  width: 80%;
}

.error-level-tag {
  min-width: 75px;
}

.table-expand-area{
  background-color: #f5f7f9;
}

.mission-table {

}

.subtask-table {
  width: 80%;
  margin: 0 auto;
  background-color: #f0f2f5;
  border: 1px solid #bae7ff;
  border-radius: 4px;
}

::v-deep .mission-table .el-table__header th {
  background-color: #f0f7ff;
  color: #2c3e50;
  font-weight: 600;

}

::v-deep .subtask-table .el-table__header th {
  background-color: #f0f4f8;
  color: #34495e;
  font-weight: 500;

}

::v-deep .mission-table .el-table__expanded-cell{
  padding: 0;
}

::v-deep .el-pagination {
  text-align: center;
}
</style>
